import * as english from './english.json';
import * as french from './french.json';

const languages = {
  en: english,
  fr: french,
};
export default languages;
